module.exports = __webpack_public_path__ + "static/media/dribbble-social-media-svgrepo-com.466e4dad.svg";